import { Form } from "react-bootstrap";
import { CrudDateModel } from "./crudInputModel";
import { RequiredAsterisks } from "../../Asterisks/requiredAsterisks";
import DatePicker, { registerLocale } from "react-datepicker";
import { nl } from "date-fns/locale";

import "react-datepicker/dist/react-datepicker.css";
import { useEffect } from "react";

export const CrudDateInput = ({
  validationSchema,
  form,
  name,
  label,
  disabled,
  t,
  required,
  datePickerOptions,
}: CrudDateModel) => {
  useEffect(() => {
    registerLocale("nl", nl);
  }, []);

  return (
    <form.Field
      key={name}
      name={name}
      validators={{
        onSubmit: validationSchema,
      }}
    >
      {(field) => {
        return (
          <Form.Group className="mb-3">
            <Form.Label>
              {label} {required && <RequiredAsterisks />}
            </Form.Label>
            <DatePicker
              {...datePickerOptions}
              id={field.name}
              key={field.name}
              name={field.name}
              selected={field.state.value ? new Date(field.state.value) : null}
              onBlur={field.handleBlur}
              onChange={(e) => {
                field.handleChange(e);
              }}
              className={"form-control"}
              wrapperClassName={"w-100"}
              disabled={disabled}
              dateFormat="P"
              showWeekNumbers
              showIcon
              calendarStartDay={1}
              locale="nl"
            />

            {field.state.meta.errors && field.state.meta.errors[0] ? (
              <Form.Control.Feedback type="invalid">
                {t(field.state.meta.errors[0])}
              </Form.Control.Feedback>
            ) : null}
          </Form.Group>
        );
      }}
    </form.Field>
  );
};
